import { isEmpty } from "lodash";
import { DatePicker, Popover } from "element-ui";

export default {
  name: "DateRangeFilterPopover",
  render(h) {
    const self = this;
    // icon
    const arrowIcon = h("i", { class: this.dateColumn.icon[this.open] });
    // column title
    const title = h(
      "span",
      {
        class: {
          "curious-blue": self.blue,
        },
      },

      ["Date"]
    );
    // open date range button
    const dateButton = h(
      "span",
      {
        class: { "el-table__column-filter-trigger": true },
        on: {
          click() {
            self.$data.open = !self.$data.open;
          },
        },
        slot: "reference",
      },
      [title, arrowIcon]
    );
    // date-time picker
    const datePicker = h(DatePicker, {
      props: {
        type: "datetimerange",
        rangeSeparator: "To",
        startPlaceholder: "Start date",
        endPlaceholder: "End date",
        size: "medium",
        value: self.$props.value,
        pickerOptions: this.pickerOptions,
      },
      on: {
        input(event) {
          self.$data.open = false;
          self.$emit("input", event || []);
        },
      },
    });

    // popover
    const popover = () => {
      return h(
        Popover,
        {
          props: {
            width: "fit-content",
            trigger: "manual",
            placement: "bottom",
            value: self.$data.open,
          },
          on: {
            hide() {
              self.$data.open = false;
            },
          },
        },
        [datePicker, dateButton]
      );
    };
    return popover();
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "Last Day",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last Month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        defaultTime: ["00:00:00", "23:59:59"],
        disabledDate: (date) => {
          return date > new Date();
        },
      },
      dateColumn: {
        icon: { false: "el-icon-arrow-down", true: "el-icon-arrow-up" },
      },
      open: false,
    };
  },
  computed: {
    blue() {
      return !isEmpty(this.$props.value);
    },
  },
};
